import React from "react";
import ListingLoader from "../../component/LoaderTemplate";
import NoDataFound from "../../component/NoDataFound";
import { STATUS } from "../../constant";
import { isValidArray } from "../../helper";
import AgendaList from "./AgendaListSingle";
import { AgendaListTemplate } from "../../component/LoadersTemplate";

export default ({ agendaList, agendaListDto = {}, isLoading }) => {
  return (
    <div className="agenda-details-wrapper">
      {isLoading === STATUS.LOADING ? (
        <ListingLoader
          parentClass="agenda-loader"
          times={10}
          height={234}
          children={<AgendaListTemplate />}
        />
      ) : isValidArray(agendaList) ? (
        agendaList.map((listDTO, index) => (
          <AgendaList
            agendaDetails={listDTO}
            agendaListDto={agendaListDto}
            key={index}
          />
        ))
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};
